import { getTargetTags } from 'xcipio/devices/forms/combineTargetsWithSameTypeAndValue';
import { TargetDefaultAFSelection } from 'data/customization/customization.types';
import { CaseModel } from 'data/case/case.types';
// eslint-disable-next-line import/prefer-default-export
export function afSelectionRequired(
  targetDefaultAFSelection: TargetDefaultAFSelection | undefined,
  warrantCase: Partial<CaseModel>,
  caseTargetTag: string, // target identifier as defined in the ontology file
):boolean {
  if (warrantCase.includeInWarrant === false) {
    return false
  }

  if (!targetDefaultAFSelection || !warrantCase.services) {
    return true;
  }

  const targetTags = getTargetTags(caseTargetTag);
  if (!targetTags) return true;

  let targetRequiresAFs:boolean = warrantCase.services.length === 0;

  warrantCase.services.some((service) => {
    if (targetDefaultAFSelection[service]) {
      targetTags.some((targetTag) => {
        if (targetDefaultAFSelection[service][targetTag] != null) {
          targetRequiresAFs = targetDefaultAFSelection[service][targetTag].selectionRequired ?? true;
          if (targetRequiresAFs === true) return true;
        } else {
          targetRequiresAFs = true;
          return true;
        }
        return false;
      });
    } else {
      targetRequiresAFs = true;
      return true;
    }
    return false;
  });

  return targetRequiresAFs;
}
